/**
 * O que se confere: estoque e caixa (F196, F375).
 *
 * O orçamento entrou porque é ali que a loja confere: o vendedor faz o
 * orçamento, o estoquista separa a peça e o caixa fatura depois. Rascunho ainda
 * não foi impresso; recusado, vencido, convertido e cancelado já terminaram.
 */
const CHECKABLE_STATUSES = {
    quote: ['sent', 'accepted'],
    order: ['confirmed', 'fulfilled', 'completed'],
    sale: ['confirmed', 'fulfilled', 'completed'],
};
export const isCheckable = (kind, status) => CHECKABLE_STATUSES[kind].includes(status);
//# sourceMappingURL=checks.js.map